<template>
    <div id="highlighter-tool-options"
         class="tool-options"
    >
        <color-selector class="color-selector-container"></color-selector>
        <size-selector></size-selector>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, watchEffect, computed, watch}  from "vue"
    import ColorSelector from "@/views/reader/tool/ColorSelector";
    import SizeSelector from "@/views/reader/tool/SizeSelector";
    import BrushSelector from "@/views/reader/tool/BrushSelector";

     export default {
        components: {
            ColorSelector,
            SizeSelector,
            BrushSelector
        },
        setup(props, context) {

            return {

            }
        }
    }

</script>

<style scoped lang="scss">

    #highlighter-tool-options {
        left:46px;
        width:248px;
        display:flex;
    }

    .color-selector-container {
        border-left:1;
        @include tool-seperator(left);
        @include tool-seperator(right);
    }

</style>